// Handle product price on sticky when quantity changed
const currentPrice = parseFloat(document.querySelector('.price-item.price-item--regular').getAttribute('data-price-no-currency'));
const currentComparePrice = parseFloat(document.querySelector('.price-item.price-item--regular').getAttribute('data-compare-price-no-currency'));
const currentCurrency = document.querySelector('.price-item.price-item--regular').getAttribute('data-currency');
document.addEventListener('quantityUpdated', () => {
  const progressBar = document.querySelector('product-progress-bar');
  const priceSale = document.querySelector('.product__info-wrapper .price-exm__container .price__sale');
  const priceRegular = document.querySelector('.product__info-wrapper .price-exm__container .price__regular');
  const stickyPriceSale = document.querySelector('.sticky-atc-banner .price__sale');
  const stickyPriceRegular = document.querySelector('.sticky-atc-banner .price__regular');
  let currentQuantity;

  // Avoid error if the quantity input don't exist, if it's existing, currentQuantity take the value of the quantity input, else we set the variable to 1
  if (document.querySelector('.product-form__input .quantity__input')) {
    currentQuantity = parseInt(document.querySelector('.product-form__input .quantity__input').value);
  } else {
    currentQuantity = 1;
  }
  ;

  // Get all price and compare at price of the page
  const priceElems = document.querySelectorAll('.price-exm__container .price-item.price-item--sale, .sticky-atc-banner .price-item.price-item--sale, #button-sticky__with-variants .price-item.price-item--sale');
  const compareAtPriceElems = document.querySelectorAll('.price-exm__container .price-item.price-item--regular, #button-sticky__with-variants .price__regular, #button-sticky__with-variants .price-item.price-item--regular');

  // The regular price is calculated with the price of the product (quantity == 1), and we multiplied by the quantity set
  const newRegularPrice = currentPrice * currentQuantity;
  const newRegularPriceTraillingZero = newRegularPrice.toFixed(2).replace('.', ',') + currentCurrency;

  // If there is no progress bar, we only update the price and compare at price based on quantity
  if (!progressBar) {
    priceElems.forEach(price => {
      price.textContent = newRegularPriceTraillingZero;
    });
    if (currentComparePrice > currentPrice) {
      compareAtPriceElems.forEach(price => {
        price.textContent = (currentComparePrice * currentQuantity).toFixed(2).replace('.', ',') + currentCurrency;
      });
    }
    ;
    return;
  }
  ;

  // Set in the compare at price elem, the current price * quantity (the real price is discounted based on the progress bar)
  compareAtPriceElems.forEach(price => {
    price.textContent = newRegularPriceTraillingZero;
  });

  // Wait the end of the progress bar animation
  if (progressBar && currentQuantity > 1) {
    handleDiscount();
  } else if (progressBar && currentQuantity < 2) {
    priceSale.style.display = 'none';
    stickyPriceSale.style.display = 'none';
    priceRegular.style.display = 'block';
    stickyPriceRegular.style.display = 'block';
    document.querySelector('.vip-price__final-price').textContent = document.querySelector('[new-price]').getAttribute('new-price');
  }
  ;

  // Handle progress bar degressive offer logic
  function handleDiscount() {
    let currentStep;

    // Avoid error, if the current quantity is > 5 we get the Attribute of the last step
    if (currentQuantity < 5) {
      currentStep = document.querySelector(`[data-step="${currentQuantity}"]`).getAttribute('data-step');
    } else {
      currentStep = document.querySelector(`[data-step="4"]`).getAttribute('data-step');
    }
    ;
    priceSale.style.display = 'block';
    stickyPriceSale.style.display = 'block';
    priceRegular.style.display = 'none';
    stickyPriceRegular.style.display = 'none';

    // Get the current vip Price
    const vipPrice = parseFloat(document.querySelector('[new-price2]').getAttribute('new-price2')) / 100;
    // Get the current discount 
    const discount = parseFloat(document.querySelector(`.product-progress-bar__items-wrapper [data-quantity="${currentStep}"] [data-discount]`).getAttribute('data-discount'));

    // Discount price is calculated here
    const newDiscountPrice = currentPrice * currentQuantity - discount;
    let newVipPrice;
    if (currentQuantity == 2) {
      newVipPrice = vipPrice * currentQuantity;
    } else {
      newVipPrice = newDiscountPrice;
    }
    ;
    document.querySelector('.vip-price__final-price').textContent = newVipPrice.toFixed(2).replace('.', ',') + currentCurrency;

    // Update the price with the discounted price based on degressive offer
    priceElems.forEach(price => {
      price.textContent = newDiscountPrice.toFixed(2).replace('.', ',') + currentCurrency;
    });
  }
  ;
});